import { Box, Typography } from '@mui/material';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    ReferenceLine, ResponsiveContainer,
} from 'recharts';
import { styles } from './styles';
import { BarTopLabel, ChartLegend, DeltaRow, getBarDomain, RoundedBar } from './utils';

const AvgTripsChart = ({ data }) => {
    const chartData = (data || [])
        .map(d => ({
            day: d?.dayLabel,
            current: parseFloat(d?.avgCurrentWeek?.toFixed(2)),
            prev: parseFloat(d?.avgPrevWeek?.toFixed(2)),
        }))
        .filter(d => d.current > 0 || d.prev > 0);

    const deltas = chartData.map(d => ({
        day: d?.day,
        delta: +(d?.current - d?.prev).toFixed(2)
    }));

    // ← Calculate from RAW data, not filtered chartData
    // const calcAvgRaw = (key) => {
    //     const all = (data || []).map(d =>
    //         parseFloat((key === 'current' ? d?.avgCurrentWeek : d?.avgPrevWeek)?.toFixed(2) || 0)
    //     );
    //     const nonZero = all.filter(v => v > 0);
    //     return nonZero.length
    //         ? +(nonZero.reduce((s, v) => s + v, 0) / nonZero.length).toFixed(2)
    //         : 0;
    // };

    // const avgs = {
    //     cw: calcAvgRaw('current'),
    //     pw: calcAvgRaw('prev'),
    // };

    return (
        <Box sx={styles.chartCard}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                <Typography sx={styles.chartTitle}>📈 Average Trips Per Vehicle — Day Wise comparison</Typography>
                <ChartLegend currentColor="#6a3db8" prevColor="#c8aff0" avgCWColor="#6a3db8" />
            </Box>
            <DeltaRow deltas={deltas} />
            <ResponsiveContainer width="100%" height={250}>
                <BarChart data={chartData} barGap={2} margin={{ top: 16, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid vertical={false} stroke="#f0f0f0" />
                    <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fontSize: 14 }} />
                    <YAxis domain={getBarDomain(chartData, 1)} tickCount={7} axisLine={false} tickLine={false} tick={{ fontSize: 15 }} />
                    <Tooltip />
                    {/* {avgs.cw > 0 && (
                        <ReferenceLine
                            y={avgs.cw}
                            stroke="#6a3db8"
                            strokeWidth={1.5}
                            label={{ value: avgs.cw, position: 'right', fontSize: 10, fill: '#6a3db8' }}
                        />
                    )}
                    {avgs.pw > 0 && (
                        <ReferenceLine
                            y={avgs.pw}
                            stroke="#e07b39"
                            strokeDasharray="5 4"
                            strokeWidth={1.5}
                            label={{ value: avgs.pw, position: 'right', fontSize: 10, fill: '#e07b39' }}
                        />
                    )} */}
                    <Bar dataKey="current" fill="#1a3a7c" maxBarSize={28} label={<BarTopLabel />} shape={<RoundedBar />} />
                    <Bar dataKey="prev" fill="#a8b8d8" maxBarSize={28} label={<BarTopLabel />} shape={<RoundedBar />} />
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
};
export default AvgTripsChart;